import { render, staticRenderFns } from "./gl-status-popover.vue?vue&type=template&id=612cabd3&scoped=true"
import script from "./gl-status-popover.vue?vue&type=script&lang=js"
export * from "./gl-status-popover.vue?vue&type=script&lang=js"
import style0 from "./gl-status-popover.vue?vue&type=style&index=0&id=612cabd3&prod&lang=css"
import style1 from "./gl-status-popover.vue?vue&type=style&index=1&id=612cabd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cabd3",
  null
  
)

export default component.exports